import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "titleize" })
export class TitleizePipe implements PipeTransform {
  public transform(str: string) {
    if (!str) {
      return "";
    }
    return str.charAt(0).toUpperCase() + str.substr(1).replace(/[A-Z]/g, " $&");
  }
}
